import { render, staticRenderFns } from "./KlasusLevel4.vue?vue&type=template&id=03c76905&scoped=true"
import script from "./KlasusLevel4.vue?vue&type=script&lang=js"
export * from "./KlasusLevel4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c76905",
  null
  
)

export default component.exports